import {
  FORM_DATA_KEY_BY_KIND,
  INVOICE_DATA_FIELDS,
  OPTIONAL_VISIBLE_FIELDS,
  REQUIRED_FIELDS_BY_KIND
} from "../invoiceFields";

const BUSINESS_ACTIVITY_KIND_FIELD = "businessActivityKind";

const backendFieldNamesToFrontendFieldNames = {
  first_name: INVOICE_DATA_FIELDS.FIRST_NAME,
  last_name: INVOICE_DATA_FIELDS.LAST_NAME,
  nip: INVOICE_DATA_FIELDS.NIP,
  company_name: INVOICE_DATA_FIELDS.COMPANY_NAME,
  street: INVOICE_DATA_FIELDS.STREET,
  street_number: INVOICE_DATA_FIELDS.STREET_NUMBER,
  flat_number: INVOICE_DATA_FIELDS.FLAT_NUMBER,
  city: INVOICE_DATA_FIELDS.CITY,
  postal_code: INVOICE_DATA_FIELDS.POSTAL_CODE,
  country: INVOICE_DATA_FIELDS.COUNTRY,
  business_activity_kind: BUSINESS_ACTIVITY_KIND_FIELD
};

export const fieldNameToFieldLabeld = {
  [INVOICE_DATA_FIELDS.FIRST_NAME]: "invoice-form_first-name",
  [INVOICE_DATA_FIELDS.LAST_NAME]: "invoice-form_last-name",
  [INVOICE_DATA_FIELDS.NIP]: "invoice-form_company-nip",
  [INVOICE_DATA_FIELDS.COMPANY_NAME]: "invoice-form_company-name",
  [INVOICE_DATA_FIELDS.STREET]: "invoice-form_street",
  [INVOICE_DATA_FIELDS.STREET_NUMBER]: "invoice-form_street-number",
  [INVOICE_DATA_FIELDS.FLAT_NUMBER]: "invoice-form_flat-number",
  [INVOICE_DATA_FIELDS.CITY]: "invoice-form_city",
  [INVOICE_DATA_FIELDS.POSTAL_CODE]: "invoice-form_postal-code",
  [INVOICE_DATA_FIELDS.COUNTRY]: "invoice-form_country",
  [BUSINESS_ACTIVITY_KIND_FIELD]: "invoice-form_business-activity-kind"
};

const FORM_DATA_KEYS = Object.values(FORM_DATA_KEY_BY_KIND);

function getFormKeysForField(feFieldName) {
  const keys = [];
  for (const kind of Object.keys(REQUIRED_FIELDS_BY_KIND)) {
    const visibleFields = [
      ...REQUIRED_FIELDS_BY_KIND[kind],
      ...OPTIONAL_VISIBLE_FIELDS
    ];
    if (visibleFields.includes(feFieldName)) {
      keys.push(FORM_DATA_KEY_BY_KIND[kind]);
    }
  }
  return keys;
}

function getBackendFieldNameFromAttr(attr) {
  if (typeof attr !== "string") return attr;
  return attr.includes(".") ? attr.split(".").pop() : attr;
}

function emptyFormErrors() {
  return FORM_DATA_KEYS.reduce((acc, key) => {
    acc[key] = {};
    return acc;
  }, {});
}

/**
 * API validation error item (e.g. from updateSavedInvoiceData failure).
 * @typedef {{ attr: string, detail: string, code?: string }} ApiValidationErrorItem
 */

/**
 * Transforms flat API validation errors into form errors keyed by form slice.
 * When activeFormDataKey is provided, errors are placed only on that slice.
 *
 * @param {ApiValidationErrorItem[]} [errors] - data.errors from API response
 * @param {string} [activeFormDataKey] - e.g. "otherBusinessData" from saga
 * @returns {Record<string, Record<string, string>>}
 */
export function updateSavedInvoiceDataErrorsToFormErrors(
  errors,
  activeFormDataKey
) {
  const formErrors = emptyFormErrors();

  if (!Array.isArray(errors) || errors.length === 0) {
    return formErrors;
  }

  for (const item of errors) {
    const attr = item?.attr;
    const detail = item?.detail;

    if (attr == null || detail == null) {
      continue;
    }

    const backendFieldName = getBackendFieldNameFromAttr(attr);
    const frontendFieldName =
      backendFieldNamesToFrontendFieldNames[backendFieldName];

    if (!frontendFieldName) {
      continue;
    }

    const targetKeys = activeFormDataKey
      ? [activeFormDataKey]
      : frontendFieldName === BUSINESS_ACTIVITY_KIND_FIELD
        ? FORM_DATA_KEYS
        : getFormKeysForField(frontendFieldName);

    for (const key of targetKeys) {
      if (formErrors[key]) {
        formErrors[key][frontendFieldName] = detail;
      }
    }
  }

  return formErrors;
}
